<template>
  <div class="restaurant-details">
    <img v-if="restaurant.imageUrl" class="restaurant-details-image" :src="restaurant.imageUrl"
      :alt="restaurant.companyName || restaurant.displayName" />

    <div class="restaurant-details-content">
      <h3>{{ restaurant.companyName || restaurant.displayName }}</h3>

      <div class="restaurant-details-item">
        <img :src="locationPin" alt="Location" class="restaurant-details-icon" />
        <p>{{ restaurant.streetAddress }}, {{ restaurant.city }}, {{ restaurant.postalCode }}</p>
      </div>

      <div v-if="restaurant.hours" class="restaurant-details-item">
        <img :src="clock" alt="Hours" class="restaurant-details-icon" />
        <p>{{ restaurant.hours }}</p>
      </div>

      <div v-if="restaurant.websiteUrl" class="restaurant-details-item">
        <img :src="globe" alt="Website" class="restaurant-details-icon" />
        <a :href="restaurant.websiteUrl" target="_blank" rel="noopener noreferrer">
          {{ `${t('map.visit_website')}` }}
        </a>
      </div>

      <div class="restaurant-details-item">
        <img :src="paperPlane" alt="Distance" class="restaurant-details-icon" />
        <p>{{ `${formatDistance(restaurant.distance)} ${t('map.from_location')}` }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import locationPin from '@/assets/icons/location-pin.svg';
import clock from '@/assets/icons/clock-regular.svg';
import globe from '@/assets/icons/globe.svg';
import paperPlane from '@/assets/icons/paper-plane.svg';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  restaurant: { type: Object, required: true }
});

const formatDistance = d => (d < 1 ? `${Math.round(d * 1000)} m` : `${d.toFixed(1)} km`);

</script>

<style scoped lang="scss">
@import "~bulma/sass/utilities/_all.sass";

@include until($desktop) {
    .restaurant-details {
      height: auto;
      background-color: white;
    }
}

.restaurant-details-content {
  padding: 16px;
  h3 {
    margin: 0 0 16px;
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }
}
.restaurant-details-item {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: flex-start;
}
.restaurant-details-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  flex-shrink: 0;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.restaurant-details-image {
  height: 200px;
  width: 100%;
  object-fit: cover;
}
</style>
